import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from './ui/tooltip';

/**
 * A tiny "?" affordance that deep-links to the matching Help Center guide.
 * Usage: <HelpDot guide="reveal-and-reports" label="Learn about revealing contacts" />
 */
export function HelpDot({ guide, label = 'Open the related guide', className = '' }) {
  const navigate = useNavigate();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); navigate(`/help?guide=${guide}`); }}
            className={`inline-flex h-4 w-4 items-center justify-center text-muted-foreground/70 transition-colors hover:text-primary ${className}`}
            data-testid={`help-dot-${guide}`}
            aria-label={label}
          >
            <HelpCircle className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default HelpDot;
